import { MarketPostura } from 'src/solace';
import { MarketType } from 'src/solace/constants/marketType.enum';
import { MarketHecho } from './marketHecho.class';

export class MarketItem {
  symbol: string;
  hechos: MarketHecho;
  posturas: MarketPostura;
  instrumentType: MarketType;
  isInWatchList: boolean;
  isTrade: boolean;
  instrumentId: string; // internal ID OMS
  externalId: string; // external ID DW
}
